import OfferInclusionItem from 'components/Common/Inclusions/OfferInclusionItem'

interface Props {
  tileInclusionsList: Array<App.OfferInclusion>
}

function OfferPageIntroInclusions(props: Props) {
  const {
    tileInclusionsList,
  } = props

  return (
    <div>
      {tileInclusionsList.map(inclusion => (
        <OfferInclusionItem key={inclusion.id} inclusion={inclusion} size="large" showMinStayDescription />
      ))}
    </div>
  )
}

export default OfferPageIntroInclusions
